export const isCordova = () => {
  return typeof window !== 'undefined' && !!window.cordova;
};
export const isAndroid = () => {
  return typeof window !== 'undefined' && window.device && window.device.platform === 'Android';
};
export const isIOS = () => {
  return typeof window !== 'undefined' && window.device && window.device.platform === 'iOS';
};
